module.exports = __webpack_public_path__ + "static/img/founder3.0762929.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_img/founder3.png
// module id = UrPY
// module chunks = 0